//type
import type {
    OptionType,
    SelectComponentProps
} from '@/components/base/Select/SelectComponent/types';

//components
import { DefaultButton } from '@/components/base/Select/SelectComponent/SubComponents/SelectButton/DefaultButton';

type SelectButtonProps<TOption, TSelected> = Readonly<
    Pick<
        SelectComponentProps<TOption, TSelected>,
        'button' | 'selected' | 'disabled' | 'error' | 'buttonVariant'
    > & {
        forcedDisplay?: SelectComponentProps<TOption, TSelected>['layoutOptions']['forcedDisplay'];
        hasChevron?: SelectComponentProps<TOption, TSelected>['layoutOptions']['hasChevron'];
        isMultiple?: SelectComponentProps<TOption, TSelected>['layoutOptions']['isMultiple'];
        size?: SelectComponentProps<TOption, TSelected>['panelOptions']['size'];
    }
>;

export function SelectButton<TOption extends OptionType, TSelected extends TOption | TOption[]>({
    button,
    selected,
    disabled,
    error,
    buttonVariant,
    forcedDisplay,
    hasChevron,
    isMultiple,
    size
}: SelectButtonProps<TOption, TSelected>) {
    if (button) {
        return button({ selected, disabled, error });
    }

    return (
        <DefaultButton
            selected={selected}
            buttonVariant={buttonVariant}
            disabled={disabled}
            error={error}
            forcedDisplay={forcedDisplay}
            hasChevron={hasChevron}
            isMultiple={isMultiple}
            size={size}
        />
    );
}
